export const SET_AZURE = 'SET_AZURE';
export const CLEAR_AZURE = 'CLEAR_AZURE';

export const clearAzure = {
  type: CLEAR_AZURE,
}

export const setAzure = (data) => {
  return {
    type: SET_AZURE,
    payload: data,
  }
}